import React, { useEffect, useState, useRef } from "react"
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Select, { components } from 'react-select'
import { DebounceInput } from 'react-debounce-input'
import { toast } from 'react-toastify'
import { Dropdown, Modal } from 'react-bootstrap'
import Pagination from 'pages/parts/Pagination'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'
import DatePicker from "react-datepicker"
import { Scanner } from '@yudiel/react-qr-scanner'
import { DELETE, GET, POST, PUT } from 'helpers/api'
import { formatMoney, findIdFromArray, findFromArrayById, checkRole, formatDateBackend } from 'helpers/helpers'
import { findGroupParentBarcode } from 'helpers/productGroup'

function CreateUpdate() {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const reduxSettings = useSelector(state => state.settings)
    const reduxTransferData = useSelector(state => state.transferData)
    const reduxAccount = useSelector(state => state.account)
    const date = new Date()

    const canDelete = checkRole('POS_INVENTORY_DELETE')

    const scrollRef = useRef(null)
    const importExcelRef = useRef(null)

    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalItems: 0,
    })

    const [modalUpdateProduct, setModalUpdateProduct] = useState(false)
    const [modalNotInventored, setModalNotInventored] = useState(false)
    const [modalConfirm, setModalConfirm] = useState(false)
    const [modalActionConfirm, setModalActionConfirm] = useState(false)
    const [confirmActionType, setConfirmActionType] = useState('')
    const [modalScanner, setModalScanner] = useState(false)
    const [scannerZoom, setScannerZoom] = useState(1)
    const [barcode, setBarcode] = useState(false)
    const [searchDataExist, setSearchDataExist] = useState(false)
    const [annual, setAnnual] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [isOpen2, setIsOpen2] = useState(false)
    const [search, setSearch] = useState('')
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
    const [showAdditionalFields, setShowAdditionalFields] = useState(false)
    const [sort, setSort] = useState("");
    const [order, setOrder] = useState("");

    const [poses, setPoses] = useState([])
    const [categories, setCategories] = useState([]) // for instant create modal
    const [categoriesInitial, setCategoriesInitial] = useState([])
    const [suppliers, setSuppliers] = useState([]) // for instant create modal
    const [suppliersInitial, setSuppliersInitial] = useState([])
    const [searchData, setSearchData] = useState([])
    const [notInventoredProducts, setNotInventoredProducts] = useState([])
    const [notInvPageCount, setNotInvPageCount] = useState(0); // total pages from X-Total-Count
    const [notInvPage, setNotInvPage] = useState(0);           // current page (0-based)


    const [selectedItem, setSelectedItem] = useState({})
    const [data, setData] = useState({
        productList: [],
        list: [],
        categoryList: [],
        suppliersList: [],
        posId: null,
    })
    const [filterData, setFilterData] = useState({
        posId: reduxAccount.posId,
        search: '',
        startDate: formatDateBackend(new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())),
        endDate: formatDateBackend(new Date()),
    })

    const getPosIdFromForm = () => {
        const selected = poses.find(p => p.id === data.posId);
        return selected?.id ?? poses?.[0]?.id ?? null; // fallback: first POS
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20); // You can change default size

    const totalItems = data?.productList?.length || 0;
    const totalPages = Math.ceil(totalItems / pageSize);

    // Handle page change
    const goToNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    // Slice the data for current page
    const paginatedList = data?.productList?.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );
    useEffect(() => {

    }, [data])


    const handlePageSizeChange = (e) => {
        e.preventDefault(); // Optional but safe
        setPageSize(parseInt(e.target.value));
        setCurrentPage(1);
    };

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const start = Math.max(1, currentPage - 2);
        const end = Math.min(totalPages, currentPage + 2);
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    const mapSupplier = (s = {}) => ({
        ...s,
        id: s.id, // <- force id
        label: ' ' + (s.organizationName ?? s.name ?? ''),
        name: ' ' + (s.organizationName ?? s.name ?? ''),
    });
    const normalizeSuppliersList = (list = []) => list.map(mapSupplier);


    async function inventoryCompleted(completed = false) {
        var sendData = { ...data }
        // const sendData = {
        // 	...data,
        // 	productList: data.productList.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        // };

        for (let i = 0; i < sendData.productList.length; i++) {
            if (sendData.productList[i]['actualBalance'] < 0 || sendData.productList[i]['actualBalance'] === "") {
                sendData.error = ': ' + (i + 1) + '. ' + sendData.productList[i].productName
            }
        }

        if (sendData.error) {
            toast.error(t('ERROR') + ': ' + t('CHECK_FILLED_INPUTS') + sendData.error)
            return
        }

        // Collapse per-location rows (same product counted at multiple places)
        // into one row per balanceId. BE enforces UNIQUE (inventory_id, balance_id).
        const mergedByBalance = new Map()
        sendData.productList.forEach((row, idx) => {
            const key = (row.balanceId !== undefined && row.balanceId !== null)
                ? row.balanceId
                : `__nomerge_${idx}`
            const qty = Number(row.actualBalance) || 0
            if (!mergedByBalance.has(key)) {
                mergedByBalance.set(key, { ...row, actualBalance: qty })
            } else {
                const existing = mergedByBalance.get(key)
                existing.actualBalance = (Number(existing.actualBalance) || 0) + qty
                if (!existing.id && row.id) existing.id = row.id
            }
        })
        sendData.productList = Array.from(mergedByBalance.values()).map(row => ({
            ...row,
            differenceAmount: (row.actualBalance - row.balance) * row.price,
            divergence: row.actualBalance - row.balance,
        }))

        var response;
        if (id) {
            if (completed) {
                response = await PUT('/services/web/api/inventory-completed', sendData, { loader: true })
                if (response) {
                    dispatch({ type: 'SET_INVENTORY_CREATE_DATA', payload: {} })
                    navigate('/inventory')
                }
            } else {
                response = await PUT('/services/web/api/inventory', sendData, { loader: true })
                if (response) {
                    dispatch({ type: 'SET_INVENTORY_CREATE_DATA', payload: {} })
                    navigate('/inventory')
                }
            }
        } else {
            if (completed) {
                response = await PUT('/services/web/api/inventory-completed', sendData, { loader: true })
                if (response) {
                    dispatch({ type: 'SET_INVENTORY_CREATE_DATA', payload: {} })
                    navigate('/inventory')
                }
            } else {
                response = await POST('/services/web/api/inventory', sendData, { loader: true })
                if (response) {
                    dispatch({ type: 'SET_INVENTORY_CREATE_DATA', payload: {} })
                    navigate('/inventory')
                }
            }
        }
    }

    function clearInventoryDraftLocally() {
        setNotInventoredProducts([])
        setData(prev => ({ ...prev, productList: [] }))
        dispatch({ type: 'SET_INVENTORY_CREATE_DATA', payload: {} })
    }

    function openActionConfirm(type) {
        setConfirmActionType(type)
        setModalActionConfirm(true)
    }

    function confirmAction() {
        if (confirmActionType === 'cancel') {
            clearInventoryDraftLocally()
            navigate('/inventory')
        } else if (confirmActionType === 'draft') {
            inventoryCompleted(false)
        }
        setModalActionConfirm(false)
        setConfirmActionType('')
    }

function handleProductListChange(e, index) {
        var dataCopy = { ...data }
        if (Number(e.target.value) > 999999999) {
            toast.error(t('EXCEEDS_MAXIMUM'))
            dataCopy.productList[index][e.target.name] = ""
            setData(dataCopy)
            return;
        }
        let value = e.target.value.replace(/,/g, '.')
        value = value.replace(/[^0-9.]/g, '')
        const dotCount = (value.match(/\./g) || []).length
        if (dotCount > 1) {
            const firstDotIndex = value.indexOf('.')
            value = value.substring(0, firstDotIndex + 1) + value.substring(firstDotIndex + 1).replace(/\./g, '')
        }
        dataCopy.productList[index][e.target.name] = value
        setData(dataCopy)
    }

    async function deleteProduct(index) {
        var dataCopy = { ...data }
        if (dataCopy.productList[index].id) {
            await DELETE(
                "/services/web/api/inventory-product",
                {
                    'id': dataCopy.productList[index]['id'],
                    'posId': dataCopy['posId'],
                    'inventoryId': dataCopy['id']
                },
                { loader: true }
            )
        }
        dataCopy.productList.splice(index, 1)
        setData(dataCopy)
    }

    async function searchProduct(value) {
        if (value.length === 0) {
            setSearchData([])
            setSearchDataExist(false)
        } else {
            const normalizedSuppliers = normalizeSuppliersList(data.suppliersList || []);
            // Guruhlangan tovarning a'zo shtrix-kodi yozilgan bo'lsa, bosh tovar kodi bilan qidiramiz.
            const searchValue = (await findGroupParentBarcode(data.posId, value)) || value

            const response = await POST(
                "/services/web/api/product-inventory-list",
                {
                    name: searchValue,
                    posId: data.posId,
                    barcode,
                    categoryList: data.categoryList,
                    suppliersList: normalizedSuppliers, // <-- id now equals organizationId
                },
                { loader: true, message: false }
            );

            if (response?.data?.length === 0) {
                setSearchDataExist(true)
                return
            }

            if (/^\d+$/.test(searchValue) && response?.data?.length === 1) {
                setSearchData(response?.data)
                setSearchDataExist(false)
                addToList(0, response?.data, true)
                setSearch('')
            } else {
                setSearchData(response?.data)
            }
        }
    }

    function addToList(index, arr = [], putCursor = false) {
        var searchDataCopy;
        if (arr.length > 0) {
            searchDataCopy = arr
        } else {
            searchDataCopy = [...searchData]
        }
        searchDataCopy[index].actualBalance = ''

        var dataCopy = { ...data }
        var productIndex = dataCopy.productList.findIndex(item => item.barcode === searchDataCopy[index]['barcode'])
        if (productIndex !== -1 && productIndex !== undefined) {
            toast.warning(t('DUPLICATE'))
        }

        dataCopy.productList.push(searchDataCopy[index])
        setData(dataCopy)
        setTimeout(() => {
            const lastInput = document.getElementById(dataCopy.productList.length)
            lastInput?.select()
        }, 300)

        searchDataCopy.splice(index, 1)
        setSearchData(searchDataCopy)



        // scrollRef.current?.scrollIntoView({ behavior: "smooth" })
        if (searchDataCopy.length === 0) {
            setSearch('')
        }
    }

    async function notInventoredList(
        page = 0,
        sortParam = sort,
        orderParam = order
    ) {
        const posId = getPosIdFromForm();
        if (!posId) return;

        const arrayIds = data.productList.map(p => p.balanceId);
        const normalizedSuppliers = normalizeSuppliersList(data.suppliersList || []);

        const prepareIds = {
            startDate: filterData.startDate,
            endDate: filterData.endDate,
            balanceIds: arrayIds,
            posId,
            categoryList: data.categoryList,
            suppliersList: normalizedSuppliers,
        };

        const searchParam = filterData.search || '';

        const url =
            `/services/web/api/product-not-inventoried-list-pageable` +
            `?page=${page}` +
            `&size=${reduxSettings.size}` +
            `&search=${encodeURIComponent(searchParam)}` +
            (sortParam ? `&sort=${encodeURIComponent(sortParam)}` : "") +
            (orderParam ? `&order=${encodeURIComponent(orderParam)}` : "");

        const response = await POST(url, prepareIds, { loader: true });

        if (response) {
            const raw = response.data ?? response;

            let list = raw.map(it => ({
                ...it,
                actualBalance: it.balance,
                uniqueBalanceId: it.balanceId + Math.floor(Math.random() * 999999),
                selected: false,
            }));

            // --- enforce annual for THIS page ---
            if (annual) {
                annualActualBalance(list);
            } else {
                setNotInventoredProducts(list);
            }

            const totalCountHeader =
                response.headers?.['x-total-count'] ?? response.headers?.['X-Total-Count'];
            if (totalCountHeader) {
                const total = Number(totalCountHeader) || 0;
                setNotInvPageCount(Math.ceil(total / reduxSettings.size));
            } else {
                setNotInvPageCount(1);
            }

            setNotInvPage(page);
            setModalNotInventored(true);
        }
    }

    async function paginateNotInventored(data) {
        const selectedPage = data?.selected ?? 0;  // react-paginate style
        await notInventoredList(selectedPage);
    }

    function sortBy(key, orderBy) {
        setSort(key);
        setOrder(orderBy);
        // IMPORTANT: pass key/orderBy to avoid using stale state
        notInventoredList(0, key, orderBy);
    }

    function annualActualBalance(sourceList) {
        var notInventoredProductsCopy = [...(sourceList || notInventoredProducts)];

        if (annual) {
            var selectedExist = false;

            for (let i = 0; i < notInventoredProductsCopy.length; i++) {
                if (notInventoredProductsCopy[i]['selected']) {
                    selectedExist = true;
                    break;
                }
            }

            if (selectedExist) {
                for (let i = 0; i < notInventoredProductsCopy.length; i++) {
                    if (notInventoredProductsCopy[i]['selected']) {
                        notInventoredProductsCopy[i]['actualBalance'] = 0;
                    }
                }
            } else {
                for (let i = 0; i < notInventoredProductsCopy.length; i++) {
                    notInventoredProductsCopy[i]['actualBalance'] = 0;
                }
            }
        } else {
            for (let i = 0; i < notInventoredProductsCopy.length; i++) {
                notInventoredProductsCopy[i]['actualBalance'] = notInventoredProductsCopy[i]['balance'];
            }
        }

        setNotInventoredProducts(notInventoredProductsCopy);
    }

    function setActualBalanceModal(e, index) {
        var notInventoredProductsCopy = [...notInventoredProducts]
        notInventoredProductsCopy[index]['actualBalance'] = e.target.value
        setNotInventoredProducts(notInventoredProductsCopy)
    }

    function addToListSelectedProducts() {
        var notInventoredProductsCopy = [...notInventoredProducts]
        var dataCopy = { ...data }

        for (let i = 0; i < notInventoredProductsCopy.length; i++) {
            if (notInventoredProductsCopy[i]['selected']) {
                dataCopy.productList.unshift(notInventoredProductsCopy[i])
            }
        }
        setData(dataCopy)
        setModalNotInventored(false)
    }

    async function addToListMinusBalanceProducts() {
        const posId = getPosIdFromForm();
        if (!posId) return;

        const dataCopy = { ...data };

        // already selected ids (exclude from backend)
        const arrayIds = (dataCopy.productList || []).map(p => p.balanceId);

        // normalize suppliers like in export
        const normalizedSuppliers = normalizeSuppliersList(data.suppliersList || []);

        // request body — EXACT structure as Excel sample
        const prepareIds = {
            startDate: filterData.startDate,
            endDate: filterData.endDate,
            balanceIds: arrayIds,
            posId,
            categoryList: data.categoryList,
            suppliersList: normalizedSuppliers,
            minusBalance: true // backend will apply only b.balance < 0
        };

        // search param same logic as export
        const searchParam = filterData.search || '';

        const response = await POST(
            `/services/web/api/product-not-inventoried-list-all?search=${encodeURIComponent(searchParam)}`,
            prepareIds,
            { loader: true }
        );

        if (!response) return;

        const rows = response.data ?? response ?? [];

        // 🔑 annual ON → actualBalance = 0, else = balance (or existing)
        const normalizedRows = rows.map(item => ({
            ...item,
            actualBalance: annual
                ? 0
                : (item.actualBalance !== undefined && item.actualBalance !== null
                    ? item.actualBalance
                    : item.balance),
        }));

        // merge without duplicates
        const existingIds = new Set((dataCopy.productList || []).map(p => p.balanceId));
        const merged = [
            ...(dataCopy.productList || []),
            ...normalizedRows.filter(p => !existingIds.has(p.balanceId))
        ];

        dataCopy.productList = merged;
        setData(dataCopy);
        setModalNotInventored(false);
    }


    function addToListNotInventoredProduct(index) {
        var notInventoredProductsCopy = [...notInventoredProducts]
        var dataCopy = { ...data }

        dataCopy.productList.unshift(notInventoredProductsCopy[index])
        notInventoredProductsCopy.splice(index, 1)

        setNotInventoredProducts(notInventoredProductsCopy)

        if (notInventoredProductsCopy.length === 0) {
            setModalNotInventored(false)
        }
    }

    async function addToListNotInventoredProducts() {
        const posId = getPosIdFromForm();
        if (!posId) return;

        const dataCopy = { ...data };

        // already selected balances to exclude
        const arrayIds = (dataCopy.productList || []).map(p => p.balanceId);

        // normalize suppliers (same as in exportToExcel)
        const normalizedSuppliers = normalizeSuppliersList(data.suppliersList || []);

        // same DTO shape as exportToExcel
        const prepareIds = {
            startDate: filterData.startDate,
            endDate: filterData.endDate,
            balanceIds: arrayIds,
            posId,
            categoryList: data.categoryList,
            suppliersList: normalizedSuppliers,
        };

        // search will be sent to backend
        const searchParam = filterData.search || '';

        // call "all rows" backend endpoint (no pageable)
        const response = await POST(
            `/services/web/api/product-not-inventoried-list-all?search=${encodeURIComponent(searchParam)}`,
            prepareIds,
            { loader: true }
        );

        if (!response) return;

        // support both axios (response.data) and direct array
        const rows = response.data ?? response ?? [];

        // 🔑 annual ON → actualBalance = 0, else = balance (or existing)
        const normalizedRows = rows.map(item => ({
            ...item,
            actualBalance: annual
                ? 0
                : (item.actualBalance !== undefined && item.actualBalance !== null
                    ? item.actualBalance
                    : item.balance),
        }));

        // merge with existing productList, avoid duplicates by balanceId
        const existingIds = new Set((dataCopy.productList || []).map(p => p.balanceId));
        const merged = [
            ...(dataCopy.productList || []),
            ...normalizedRows.filter(p => !existingIds.has(p.balanceId)),
        ];

        dataCopy.productList = merged;
        setData(dataCopy);

        // since it's ADD_ALL, clear modal list and close it
        setNotInventoredProducts([]);
        setModalNotInventored(false);
    }



    function markAsSelected(bool, index) {
        var notInventoredProductsCopy = [...notInventoredProducts]
        notInventoredProductsCopy[index]['selected'] = bool
        setNotInventoredProducts(notInventoredProductsCopy)
    }

    async function exportToExcel() {
        const posId = getPosIdFromForm();
        if (!posId) return;

        // same as in notInventoredList
        const arrayIds = data.productList.map(p => p.balanceId);
        const normalizedSuppliers = normalizeSuppliersList(data.suppliersList || []);

        const prepareIds = {
            startDate: filterData.startDate,
            endDate: filterData.endDate,
            balanceIds: arrayIds,
            posId,
            categoryList: data.categoryList,
            suppliersList: normalizedSuppliers,
        };

        // search will be sent to backend
        const searchParam = filterData.search || '';

        // NEW: call "all rows" backend endpoint (no pageable)
        const response = await POST(
            `/services/web/api/product-not-inventoried-list-all?search=${encodeURIComponent(searchParam)}`,
            prepareIds,
            { loader: true }
        );

        if (!response) return;

        // support both axios (response.data) and direct array
        const rows = response.data ?? response ?? [];

        // build Excel rows
        const excelHeaders = [[
            t('NAME_OF_PRODUCT'),
            t('BARCODE'),
            t('PRICE'),
            t('EXPECTED_BALANCE'),
        ]];

        for (let i = 0; i < rows.length; i++) {
            const item = rows[i];
            const excelItems = [];
            excelItems.push(item.productName);
            excelItems.push(item.barcode);
            excelItems.push(item.price);    // or formatMoney(item.price) if you prefer
            excelItems.push(item.balance);
            excelHeaders.push(excelItems);
        }

        const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
        styleExcelSheet(ws)
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
        XLSX.writeFile(wb, t('NOT_INVENTORED') + '.xlsx');
    }

    async function exportToExcelAll() {
        const response = await GET('/services/web/api/inventory-group-excel/' + id, {}, { loader: true })

        var excelHeaders = []
        excelHeaders.push([
            t('NAME_OF_PRODUCT'), t('BARCODE'), t('UNIT'), t('PRICE'), t('EXPECTED_BALANCE'),
            t('COUNTED')
        ])

        for (let i = 0; i < response.length; i++) {
            var excelItems = []
            excelItems.push(response[i]['productName'])
            excelItems.push(response[i]['barcode'])
            excelItems.push(response[i].uomName)
            excelItems.push(formatMoney(response[i]['price']))
            excelItems.push(response[i]['balance'])
            excelItems.push(response[i]['actualBalance'])
            excelHeaders.push(excelItems)
        }
        const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
        styleExcelSheet(ws)
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
        XLSX.writeFile(wb, t('INVENTORY') + ".xlsx");
    }

    function exportCurrentTableToExcel() {
        const rows = data?.productList || []
        if (!rows.length) {
            toast.warning(t('NO_DATA'))
            return
        }

        const excelHeaders = [[
            t('NAME_OF_PRODUCT'),
            t('BARCODE'),
            t('UNIT'),
            t('PRICE'),
            t('EXPECTED_BALANCE'),
            t('COUNTED'),
            t('DIVERGENCE'),
            t('COST_DIFFERENCE'),
        ]]

        for (let i = 0; i < rows.length; i++) {
            const item = rows[i]
            const divergence = Number(item.actualBalance || 0) - Number(item.balance || 0)
            const diffAmount = divergence * Number(item.price || 0)
            excelHeaders.push([
                item.productName,
                item.barcode,
                item.uomName,
                formatMoney(item.price),
                item.balance,
                item.actualBalance,
                formatMoney(divergence),
                formatMoney(diffAmount),
            ])
        }

        const ws = XLSX.utils.aoa_to_sheet(excelHeaders)
        styleExcelSheet(ws)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
        XLSX.writeFile(wb, t('INVENTORY') + "_table.xlsx")
    }

    function downloadImportTemplate() {
        const excelHeaders = [[
            t('NAME_OF_PRODUCT'),
            t('BARCODE'),
            t('COUNTED')
        ]]
        const ws = XLSX.utils.aoa_to_sheet(excelHeaders)
        styleExcelSheet(ws)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
        XLSX.writeFile(wb, t('INVENTORY') + "_import_template.xlsx")
    }

    async function importFromExcel(e) {
        const file = e?.target?.files?.[0]
        if (!file) return
        if (!data.posId) {
            toast.warning(t('CHOOSE_POS'))
            e.target.value = ''
            return
        }

        try {
            const buffer = await file.arrayBuffer()
            const workbook = XLSX.read(buffer, { type: 'array' })
            const firstSheet = workbook.SheetNames[0]
            const rows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], { header: 1 })
            const bodyRows = rows.slice(1)

            const normalizedSuppliers = normalizeSuppliersList(data.suppliersList || [])
            const dataCopy = { ...data, productList: [...(data.productList || [])] }
            let added = 0
            let updated = 0
            let skipped = 0

            for (let i = 0; i < bodyRows.length; i++) {
                const row = bodyRows[i] || []
                const barcodeVal = String(row[1] ?? row[0] ?? '').trim()
                if (!barcodeVal) continue

                const countedRaw = row[2] ?? ''
                const counted = String(countedRaw).trim() === '' ? '' : Number(String(countedRaw).replace(',', '.'))
                const actualBalance = Number.isFinite(counted) ? counted : ''

                const requestBase = {
                    name: barcodeVal,
                    posId: data.posId,
                    barcode: true,
                }
                // 1) Avval joriy filterlar bilan qidiramiz
                const responseFiltered = await POST(
                    "/services/web/api/product-inventory-list",
                    {
                        ...requestBase,
                        categoryList: data.categoryList,
                        suppliersList: normalizedSuppliers,
                    },
                    { loader: false, message: false }
                )
                let foundList = responseFiltered?.data || []
                let found =
                    foundList.find((x) => String(x.barcode || '') === barcodeVal) ||
                    (foundList.length === 1 ? foundList[0] : null)

                // 2) Topilmasa filterlarsiz ham tekshiramiz (Excel import to'liq ishlashi uchun)
                if (!found) {
                    const responseAll = await POST(
                        "/services/web/api/product-inventory-list",
                        requestBase,
                        { loader: false, message: false }
                    )
                    foundList = responseAll?.data || []
                    found =
                        foundList.find((x) => String(x.barcode || '') === barcodeVal) ||
                        (foundList.length === 1 ? foundList[0] : null)
                }

                if (!found) {
                    skipped += 1
                    continue
                }

                const productIndex = dataCopy.productList.findIndex((p) => p.barcode === found.barcode)
                if (productIndex >= 0) {
                    dataCopy.productList[productIndex] = {
                        ...dataCopy.productList[productIndex],
                        actualBalance,
                    }
                    updated += 1
                } else {
                    dataCopy.productList.push({
                        ...found,
                        actualBalance,
                    })
                    added += 1
                }
            }

            setData(dataCopy)
            if (added || updated) {
                toast.success(`${t('SUCCESS')}: +${added}, ${t('EDIT')}: ${updated}`)
            }
            if (skipped) {
                toast.warning(`${skipped} ${t('PRODUCT_NOT_FOUND')}`)
            }
        } catch (err) {
            toast.error(t('ERROR'))
        } finally {
            e.target.value = ''
        }
    }

    async function showProductUpdateModal(bool, index) {
        if (bool) {
            var response = await GET(`/services/web/api/product/${data.productList[index]['productId']}`, selectedItem, { loader: true })
            response.index = index
            setSelectedItem(response)
        } else {
            setSelectedItem({})
        }
        setModalUpdateProduct(bool)
    }

    async function changeProduct(e) {
        e.preventDefault()

        var dataCopy = { ...data }
        await PUT('/services/web/api/product', selectedItem, { loader: true })
        dataCopy.productList[selectedItem.index]['productName'] = selectedItem.name
        setData(dataCopy)
        showProductUpdateModal(false)
    }

    function setReduxProducts(data) {
        var dataCopy = { ...data }
        if (reduxTransferData.inventoryCreateData?.productList && reduxTransferData.inventoryCreateData?.productList?.length) {
            dataCopy = reduxTransferData.inventoryCreateData
        }
        setData(dataCopy)
    }

    async function getPoses() {
        const response = await GET('/services/web/api/pos-helper', {}, { loader: true })
        if (!response) return;

        setPoses(response);

        if (!id) {
            if (reduxSettings.posId && findIdFromArray(response, reduxSettings.posId)) {
                setReduxProducts({ ...data, posId: reduxSettings.posId });
            } else {
                setReduxProducts({ ...data, posId: response[0]?.id });
            }
        }

        if (id) {
            const temporaryData = await GET('/services/web/api/inventory/' + id, {}, { loader: true });

            if (temporaryData?.productList?.length > 150) {
                temporaryData.list = temporaryData.productList.slice(
                    temporaryData.productList.length - 100,
                    temporaryData.productList.length
                );
                setPagination(p => ({ ...p, totalItems: temporaryData.productList.length }));
            }

            // keep POS from the form
            const posIdResolved =
                data.posId ??
                temporaryData.posId ??
                poses?.[0]?.id ??
                null;


            // normalize suppliers in loaded inventory
            const normalizedSuppliersList = normalizeSuppliersList(temporaryData.suppliersList || []);

            setData(prev => ({
                ...prev,
                ...temporaryData,
                suppliersList: normalizedSuppliersList,
                posId: posIdResolved,
            }));



            setTimeout(() => {
                const lastChildElement = scrollRef.current?.lastElementChild;
                lastChildElement?.scrollIntoView({ behavior: 'instant' });
            }, 300);
        }
    }

    async function getCategories() {
        const response = await GET('/services/web/api/product-category-helper', {}, { loader: true })
        var arr = []
        for (let i = 0; i < response.length; i++) {
            response[i]['label'] = ' ' + response[i]['name']
            response[i].child = false;
            if (response[i].parentId !== 0) {
                const index = response.findIndex(x => x.id === response[i].parentId)
                if (index !== -1) {
                    response[i].child = true;
                    if (response[index].options && response[index].options.length > 0) {
                        response[index].options.push(response[i])
                    } else {
                        response[index].options = [response[i]]
                    }
                } else {
                    arr.push(response[i])
                }
            } else {
                arr.push(response[i])
            }
        }
        setCategories(arr)
        setCategoriesInitial(response)
    }

    async function getSuppliers() {
        const response = await GET('/services/web/api/organization-balance-helper', {}, { loader: true });
        if (!response) return;

        const mapped = normalizeSuppliersList(response);
        setSuppliers(mapped);
        setSuppliersInitial(mapped);
    }

    function onScroll(element) {
        if (element.currentTarget.scrollTop <= 0) {
            setData({ ...data, list: data.productList.slice(data.productList.length - (100 * pagination.currentPage), data.productList.length) })
            setPagination({ ...pagination, currentPage: pagination.currentPage + 1 })
            setTimeout(() => {
                scrollRef.current.scrollTop = 100 * 37.27;
            }, 100);
        }
    }

    useEffect(() => {
        getPoses()
        getCategories()
        getSuppliers()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        annualActualBalance()
    }, [annual]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (search.length > 1) {
            searchProduct(search)
        }
        if (search.length === 0) {
            searchProduct('')
        }
    }, [search]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (reduxTransferData?.inventoryCreateData?.productList?.length > 0 && data.productList?.length === 0) {
            return;
        }
        if (id) {
            return;
        }
        dispatch({ type: 'SET_INVENTORY_CREATE_DATA', payload: data })
    }, [data]) // eslint-disable-line react-hooks/exhaustive-deps	

    useEffect(() => {
        if (!modalNotInventored) return;
        const posId = getPosIdFromForm();
        if (posId && filterData.startDate && filterData.endDate) {
            notInventoredList();
        }
    }, [filterData.startDate, filterData.endDate, poses, data.posId, filterData.search]); // eslint-disable-line react-hooks/exhaustive-deps


    function selectChildCategory(selectedOption) {
        var dataCopy = { ...data }
        for (let i = 0; i < selectedOption?.options?.length; i++) {
            dataCopy?.categoryList?.push(selectedOption?.options[i])
        }
        setData(dataCopy)
        setIsOpen(false)
    }

    const GroupHead = props => {
        return (
            <div style={{
                padding: '0',
                color: '#999',
                fontWeight: 'bold',
                fontSize: '.8rem'
            }}
                onClick={() => selectChildCategory(props?.data)}>
                <components.Option {...props} />
            </div>
        );
    };

    const searchRef = useRef(null);
    useEffect(() => {
        const handleKeyPress = (e) => {
            const active = document.activeElement;
            const isEditable =
                active &&
                (active.tagName === "INPUT" || active.tagName === "TEXTAREA") &&
                !active.disabled &&
                !active.readOnly;

            if (!isEditable) {
                // Agar hech qanday input fokusda bo'lmasa
                searchRef.current.focus();
            }
        };

        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    const Option = props => {
        return (
            <div style={{
                padding: props.data.child ? '0 0 0 20px' : '0',
                color: '#999',
                fontWeight: props.data.parentId === 0 ? 'bold' : 'normal',
                fontSize: '.8rem'
            }}>
                <components.Option {...props} />
            </div>
        );
    };

    return (
        <>
            {isMobile ? (
                // MOBILE VERSION
                <div style={{ margin: '-14px', padding: '10px', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
                    {/* Header - Mobile */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="m-0 fw-bold">{t('INVENTORY')}</h5>
                        <button className="btn btn-primary btn-sm" onClick={() => notInventoredList()}>
                            {t('NOT_INVENTORED')}
                        </button>
                    </div>

                    {/* Asosiy ma'lumotlar - Mobile */}
                    <div className="card mb-3">
                        <div className="card-body p-3">
                            {id &&
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="badge bg-danger">{t('ONLINE')}</span>
                                    <div className="table-action-button table-action-danger-button" onClick={() => exportToExcelAll()}>
                                        <i className="uil-file-alt"></i>
                                    </div>
                                </div>
                            }
                            <div className="form-group mb-2">
                                <label className="small">{t('POS')}<span className="required-mark">*</span></label>
                                <Select
                                    isDisabled={data.productList?.length > 0}
                                    value={poses.find(option => option.id === data.posId)}
                                    options={poses}
                                    onChange={(option) => setData({ ...data, 'posId': option.id })}
                                    placeholder=""
                                    noOptionsMessage={() => t('LIST_IS_EMPTY')}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>

                            {/* Qo'shimcha maydonlar - yig'iladigan */}
                            <div className="d-flex justify-content-between align-items-center cursor" onClick={() => setShowAdditionalFields(!showAdditionalFields)}>
                                <span className="text-primary small fw-bold">{t('ADDITIONAL_INFO')}</span>
                                <i className={`uil ${showAdditionalFields ? 'uil-angle-up' : 'uil-angle-down'} text-primary`}></i>
                            </div>

                            {showAdditionalFields && (
                                <div className="mt-2">
                                    <div className="row g-2">
                                        <div className="col-6">
                                            <label className="small">{t('INVENTORY')} №</label>
                                            <input name="inventoryNumber" className="form-control form-control-sm" value={data.inventoryNumber || ''}
                                                onChange={(e) => setData({ ...data, 'inventoryNumber': e.target.value })} />
                                        </div>
                                        <div className="col-6">
                                            <label className="small">{t('NOTE')}</label>
                                            <input name="note" className="form-control form-control-sm" value={data.note || ''}
                                                onChange={(e) => setData({ ...data, 'note': e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="form-group mt-2">
                                        <label className="small">{t('CATEGORY')}</label>
                                        <Select
                                            components={{ GroupHeading: GroupHead, Option }}
                                            options={categories}
                                            value={data.categoryList}
                                            onChange={(options) => setData({ ...data, 'categoryList': options })}
                                            placeholder=""
                                            noOptionsMessage={() => t('LIST_IS_EMPTY')}
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            isMulti
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                    <div className="form-group mt-2">
                                        <label className="small">{t('SUPPLIERS')}</label>
                                        <Select
                                            components={{ GroupHeading: GroupHead, Option }}
                                            options={suppliers}
                                            value={data.suppliersList}
                                            onChange={(options) => setData({ ...data, suppliersList: normalizeSuppliersList(options) })}
                                            placeholder=""
                                            noOptionsMessage={() => t('LIST_IS_EMPTY')}
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => String(option.organizationId ?? option.id)}
                                            isMulti
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Mahsulotlar ro'yxati - Mobile */}
                    {data.productList?.length > 0 && (
                        <div className="card mb-3">
                            <div className="card-body p-2">
                                <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                                    <strong>{t('PRODUCTS')} ({data.productList.length})</strong>
                                    <select
                                        value={pageSize}
                                        onChange={handlePageSizeChange}
                                        className="form-select form-select-sm"
                                        style={{ width: 'auto' }}
                                    >
                                        {[20, 50, 100].map(size => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                </div>

                                {paginatedList?.map((item, index) => (
                                    <div key={index} className="border-bottom p-2 mb-2">
                                        {/* Mahsulot nomi va o'chirish */}
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <div className="fw-bold" style={{ fontSize: '14px' }}>{(pageSize * (currentPage - 1)) + index + 1}. {item.productName}</div>
                                            <div className="d-flex gap-2">
                                                <div className="table-action-button table-action-primary-button" onClick={() => showProductUpdateModal(true, (pageSize * (currentPage - 1)) + index)}>
                                                    <i className="uil uil-edit"></i>
                                                </div>
                                                <div className="table-action-button table-action-danger-button" onClick={() => deleteProduct((pageSize * (currentPage - 1)) + index)}>
                                                    <i className="uil uil-times"></i>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Ma'lumotlar */}
                                        <div className="d-flex flex-wrap gap-2 small text-muted mb-2">
                                            <span><strong>{t('BARCODE')}:</strong> {item.barcode}</span>
                                            <span><strong>{t('UNIT')}:</strong> {item.uomName}</span>
                                            <span><strong>{t('PRICE')}:</strong> {formatMoney(item.price)}</span>
                                        </div>

                                        {/* Kutilgan va Hisoblangan */}
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <label className="small text-muted">{t('EXPECTED_BALANCE')}</label>
                                                <div className="form-control form-control-sm bg-light">{formatMoney(item.balance)}</div>
                                            </div>
                                            <div className="col-6">
                                                <label className="small text-muted">{t('COUNTED')}</label>
                                                <input
                                                    type="number"
                                                    inputMode="decimal"
                                                    className={"form-control form-control-sm " + (item.actualBalance < 0 && "border-danger")}
                                                    name="actualBalance"
                                                    value={item.actualBalance}
                                                    onChange={(e) => handleProductListChange(e, (pageSize * (currentPage - 1)) + index)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* Pagination - Mobile */}
                                {totalPages > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={goToPreviousPage}
                                            disabled={currentPage === 1}
                                        >
                                            <i className="uil uil-angle-left"></i>
                                        </button>
                                        <span className="small">{currentPage} / {totalPages}</span>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={goToNextPage}
                                            disabled={currentPage === totalPages}
                                        >
                                            <i className="uil uil-angle-right"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Qidiruv - Mobile */}
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <div className="form-group position-relative m-0 flex-grow-1">
                            <DebounceInput
                                inputRef={searchRef}
                                disabled={!data.posId}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                type="text"
                                className="form-control"
                                placeholder={t('SEARCH') + '...'}
                                style={{ paddingRight: '45px' }}
                                debounceTimeout={1000}
                            />
                            {/* Ikonlar */}
                            <div className="d-flex align-items-center" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', gap: '8px' }}>
                                {searchData.length > 0 ?
                                    <i className="uil uil-times fz-20 cursor" onClick={() => { setSearchData([]); setSearch(''); setSearchDataExist(false) }}></i>
                                    :
                                    <i className={'uil uil-qrcode-scan fz-20 cursor ' + (barcode && 'text-primary')} onClick={() => setBarcode(!barcode)}></i>
                                }
                            </div>

                            {/* Qidiruv natijalari - tepaga chiqadi */}
                            {searchData.length > 0 &&
                                <span className="dropdown-search-menu" style={{ bottom: '100%', top: 'auto', marginBottom: '5px' }}>
                                    <div className="dropdown-menu-list">
                                        <span className="dropdown-menu-result">
                                            <div className="p-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                {searchData.map((item, index) => (
                                                    <div key={index} className="border-bottom p-2 mb-2">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div className="flex-grow-1">
                                                                <div className="fw-bold mb-1">{item.productName}</div>
                                                                <div className="d-flex flex-wrap gap-2 small text-muted">
                                                                    <span><strong>{t('BARCODE')}:</strong> {item.barcode}</span>
                                                                    <span><strong>{t('RESIDUE')}:</strong> {formatMoney(item.balance)} {item.uomName}</span>
                                                                </div>
                                                            </div>
                                                            <div className="table-action-button table-action-primary-button ms-2" onClick={() => addToList(index)}>
                                                                <i className="uil uil-plus"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </span>
                                    </div>
                                </span>
                            }
                            {(searchData.length === 0 && searchDataExist) &&
                                <span className="dropdown-search-menu" style={{ bottom: '100%', top: 'auto', marginBottom: '5px' }}>
                                    <div className="dropdown-menu-list d-flex justify-content-between p-2">
                                        <span className="dropdown-menu-result fz20">{t('PRODUCT_NOT_FOUND')}</span>
                                    </div>
                                </span>
                            }
                        </div>
                        {/* Kamera scanner tugma */}
                        <div style={{ width: '45px', height: '45px', borderRadius: '8px', flexShrink: 0, backgroundColor: '#198754', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setModalScanner(true)}>
                            <i className="uil uil-capture" style={{ color: '#fff', fontSize: '22px' }}></i>
                        </div>
                    </div>

                    {/* Tugmalar - Mobile */}
                    <div className="d-flex gap-2 mb-2">
                        <Dropdown className="w-100">
                            <Dropdown.Toggle className="btn btn-success w-100">
                                {t('ACTION')}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100">
                                <Dropdown.Item onClick={exportCurrentTableToExcel}>{t('SAVE_TO_FILE')}</Dropdown.Item>
                                <Dropdown.Item onClick={downloadImportTemplate}>{t('DOWNLOAD_TEMPLATE')}</Dropdown.Item>
                                <Dropdown.Item onClick={() => importExcelRef.current?.click()}>{t('IMPORT_FROM_FILE')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <input
                        ref={importExcelRef}
                        type="file"
                        hidden
                        accept=".csv, .xlsx, .xls, application/vnd.ms-excel"
                        onChange={importFromExcel}
                    />

                    <div className="d-flex flex-column gap-2">
                        <button type="button" className="btn btn-primary w-100"
                            disabled={!data.productList?.length > 0}
                            onClick={() => openActionConfirm('draft')}>
                            <i className="uil uil-save me-1"></i>{t('SAVE_TO_DRAFT')}
                        </button>
                        <button type="button" className="btn btn-success w-100"
                            disabled={!data.productList?.length > 0}
                            onClick={() => setModalConfirm(true)}>
                            <i className="uil uil-check me-1"></i>{t('COMPLETE')}
                        </button>
                        <button type="button" className="btn btn-warning w-100"
                            onClick={() => openActionConfirm('cancel')}>
                            <i className="uil uil-times me-1"></i>{t('CANCEL')}
                        </button>
                    </div>
                </div>
            ) : (
                // DESKTOP VERSION
                <>
                    <div className="page-header d-flex justify-content-between flex-wrap mb-2">
                        <div className="d-flex text-truncate">
                            <h4 className="vertical-center">
                                {t('INVENTORY')}
                            </h4>
                            <div className="vertical-center mt-1">
                                <i className="uil uil-angle-double-right fz-20"></i>
                            </div>
                            <div className="vertical-center mt-1">
                                <h6>{t('CREATE')}</h6>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex gap-2">
                                <Dropdown>
                                    <Dropdown.Toggle className="btn btn-success">
                                        {t('ACTION')}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={exportCurrentTableToExcel}>{t('SAVE_TO_FILE')}</Dropdown.Item>
                                        <Dropdown.Item onClick={downloadImportTemplate}>{t('DOWNLOAD_TEMPLATE')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => importExcelRef.current?.click()}>{t('IMPORT_FROM_FILE')}</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <button className="btn btn-primary" onClick={() => notInventoredList()}>
                                    {t('NOT_INVENTORED')}
                                </button>
                            </div>
                            <input
                                ref={importExcelRef}
                                type="file"
                                hidden
                                accept=".csv, .xlsx, .xls, application/vnd.ms-excel"
                                onChange={importFromExcel}
                            />
                        </div>
                    </div>

                    <form autoComplete="off">
                        <div className="card mb-3">
                            <div className="card-body">
                                {id ?
                                    <div className="d-flex justify-content-end align-items-center mb-2">
                                        <span className="text-danger fw-700 me-2">{t('ONLINE')}</span>
                                        <div className="table-action-button table-action-danger-button"
                                            onClick={() => exportToExcelAll()}>
                                            <i className="uil-file-alt"></i>
                                        </div>
                                    </div>
                                    :
                                    ''
                                }
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>{t('POS')}<span className="required-mark">*</span></label>
                                            <Select
                                                isDisabled={data.productList?.length > 0}
                                                value={poses.find(option => option.id === data.posId)}
                                                options={poses}
                                                onChange={(option) => setData({ ...data, 'posId': option.id })}
                                                placeholder=""
                                                noOptionsMessage={() => t('LIST_IS_EMPTY')}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>{t('INVENTORY')} №</label>
                                            <input name="inventoryNumber" className="form-control" value={data.inventoryNumber}
                                                onChange={(e) => setData({ ...data, 'inventoryNumber': e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>{t('NOTE')}</label>
                                            <input name="note" className="form-control" value={data.note}
                                                onChange={(e) => setData({ ...data, 'note': e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>{t('CATEGORY')}</label>
                                            <Select
                                                components={{ GroupHeading: GroupHead, Option }}
                                                options={categories}
                                                value={data.categoryList}
                                                onChange={(options) => setData({ ...data, 'categoryList': options })}
                                                placeholder=""
                                                noOptionsMessage={() => t('LIST_IS_EMPTY')}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                isMulti
                                                onMenuOpen={() => setIsOpen(true)}
                                                onBlur={() => setIsOpen(false)}
                                                menuIsOpen={isOpen}
                                            // isDisabled={id}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>{t('SUPPLIERS')}</label>
                                            <Select
                                                components={{ GroupHeading: GroupHead, Option }}
                                                options={suppliers}
                                                value={data.suppliersList}
                                                onChange={(options) => setData({ ...data, suppliersList: normalizeSuppliersList(options) })}
                                                placeholder=""
                                                noOptionsMessage={() => t('LIST_IS_EMPTY')}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => String(option.organizationId ?? option.id)}
                                                isMulti
                                                onMenuOpen={() => setIsOpen2(true)}
                                                onBlur={() => setIsOpen2(false)}
                                                menuIsOpen={isOpen2}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6 vertical-center">
                                        <div className="form-group position-relative m-0">
                                            <DebounceInput
                                                inputRef={searchRef}
                                                disabled={!data.posId}
                                                value={search}
                                                tabIndex={data.productList?.length + 2}
                                                onChange={(e) => setSearch(e.target.value)}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 13) {
                                                        setSearch(e.target.value)
                                                    }
                                                }}
                                                type="text"
                                                className="form-control"
                                                placeholder={t('SEARCH') + '...'}
                                                debounceTimeout={1000}
                                            />

                                            {searchData.length > 0 ?
                                                <i className="uil uil-times search-barcode" onClick={() => { setSearchData([]); setSearch(''); setSearchDataExist(false) }}></i>
                                                :
                                                <i className={'uil uil-qrcode-scan search-barcode ' + (barcode && 'text-primary')} onClick={() => setBarcode(!barcode)}></i>
                                            }

                                            {searchData.length > 0 &&
                                                <span className="dropdown-search-menu">
                                                    <div className="dropdown-menu-list">
                                                        <span className="dropdown-menu-result">
                                                            <div className="table-responsive p-3">
                                                                <table className="table-striped table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>{t('NAME_OF_PRODUCT')}</th>
                                                                            <th>{t('BARCODE')}</th>
                                                                            <th className="text-center">{t('QUANTITY')}</th>
                                                                            <th className="text-center">{t('ACTION')}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {searchData.map((item, index) => (
                                                                            <tr key={index}>
                                                                                <td>{item.productName}</td>
                                                                                <td>{item.barcode}</td>
                                                                                <td className="text-center">{item.balance} {item.uomName}</td>
                                                                                <td className="d-flex justify-content-center" onClick={() => addToList(index)}>
                                                                                    <div className="table-action-button table-action-primary-button">
                                                                                        <i className="uil uil-plus"></i>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </span>
                                            }

                                            {(searchData.length === 0 && searchDataExist) &&
                                                <span className="dropdown-search-menu">
                                                    <div className="dropdown-menu-list d-flex justify-content-between p-2">
                                                        <span className="dropdown-menu-result fz20">{t('PRODUCT_NOT_FOUND')}</span>
                                                    </div>
                                                </span>
                                            }

                                        </div>
                                    </div>
                                </div>

                                <hr />
                                <select
                                    value={pageSize}
                                    onChange={handlePageSizeChange}
                                    className="form-select form-select-sm d-inline w-auto"
                                >
                                    {[20, 50, 100].map(size => (
                                        <option key={size} value={size}>{size}</option>
                                    ))}
                                </select>
                                {data.productList?.length > 100 ?
                                    <div className="mb-3">
                                        <table className="table table-striped mb-0">
                                            <thead>
                                                <tr>
                                                    <th>{t('NAME_OF_PRODUCT')}</th>
                                                    <th className="text-center">{t('BARCODE')}</th>
                                                    <th className="text-center">{t('ARTIKUL')}</th>
                                                    <th className="text-center">{t('UNIT')}</th>
                                                    <th className="text-center">{t('PRICE')}</th>
                                                    <th className="text-center">{t('EXPECTED_BALANCE')}</th>
                                                    <th className="text-center">{t('COUNTED')}</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedList?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="custom-truncate" style={{ 'width': '30%' }}>
                                                            {(pageSize * (currentPage - 1)) + index + 1}. {item.productName}
                                                        </td>
                                                        <td className="text-center">{item.barcode}</td>
                                                        <td className="text-center">{item.artikul}</td>
                                                        <td className="text-center">{item.uomName}</td>
                                                        <td className="text-center text-nowrap">{formatMoney(item.price)}</td>
                                                        <td className="text-center text-nowrap">{formatMoney(item.balance)}</td>
                                                        <td className="d-flex justify-content-center">
                                                            <input
                                                                type="number"
                                                                className={"auto-width-input " + (item.actualBalance < 0 && "required-border")}
                                                                id={(pageSize * (currentPage - 1)) + index + 1}
                                                                tabIndex={(pageSize * (currentPage - 1)) + index + 1}
                                                                name="actualBalance"
                                                                value={item.actualBalance}
                                                                onChange={(e) => handleProductListChange(e, (pageSize * (currentPage - 1)) + index)} />
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                {canDelete &&
                                                                    <div className="table-action-button table-action-primary-button"
                                                                        onClick={() => showProductUpdateModal(true, (pageSize * (currentPage - 1)) + index)}>
                                                                        <i className="uil uil-edit"></i>
                                                                    </div>
                                                                }
                                                                <div className="table-action-button table-action-danger-button ms-2" onClick={() => deleteProduct((pageSize * (currentPage - 1)) + index)}>
                                                                    <i className="uil uil-times"></i>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div></div>
                                    </div>
                                    :
                                    <div className="mb-3">
                                        <table className="table table-striped mb-0">
                                            <thead>
                                                <tr>
                                                    <th>{t('NAME_OF_PRODUCT')}</th>
                                                    <th className="text-center">{t('BARCODE')}</th>
                                                    <th className="text-center">{t('UNIT')}</th>
                                                    <th className="text-center">{t('PRICE')}</th>
                                                    <th className="text-center">{t('EXPECTED_BALANCE')}</th>
                                                    <th className="text-center">{t('COUNTED')}</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedList?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="custom-truncate" style={{ 'width': '30%' }}>
                                                            {(pageSize * (currentPage - 1)) + index + 1}. {item.productName}
                                                        </td>
                                                        <td className="text-center">{item.barcode}</td>
                                                        <td className="text-center">{item.uomName}</td>
                                                        <td className="text-center text-nowrap">{formatMoney(item.price)}</td>
                                                        <td className="text-center text-nowrap">{formatMoney(item.balance)}</td>
                                                        <td className="d-flex justify-content-center">
                                                            <input
                                                                type="number"
                                                                className={"auto-width-input " + (item.actualBalance < 0 && "required-border")}
                                                                id={(pageSize * (currentPage - 1)) + index + 1}
                                                                tabIndex={(pageSize * (currentPage - 1)) + index + 1}
                                                                name="actualBalance"
                                                                value={item.actualBalance}
                                                                onChange={(e) => handleProductListChange(e, (pageSize * (currentPage - 1)) + index)} />
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <div className="table-action-button table-action-primary-button"
                                                                    onClick={() => showProductUpdateModal(true, (pageSize * (currentPage - 1)) + index)}>
                                                                    <i className="uil uil-edit"></i>
                                                                </div>
                                                                <div className="table-action-button table-action-danger-button ms-2" onClick={() => deleteProduct((pageSize * (currentPage - 1)) + index)}>
                                                                    <i className="uil uil-times"></i>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div></div>
                                    </div>
                                }

                                <div className="d-flex align-items-center justify-content-between mt-3">
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={goToPreviousPage}
                                            disabled={currentPage === 1}
                                        >
                                            {t('PREVIOUS')}
                                        </button>

                                        {getPageNumbers().map((page) => (
                                            <button
                                                key={page}
                                                type="button"
                                                className={`btn btn-sm me-1 ${page === currentPage ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => goToPage(page)}
                                            >
                                                {page}
                                            </button>
                                        ))}

                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary ms-2"
                                            onClick={goToNextPage}
                                            disabled={currentPage === totalPages}
                                        >
                                            {t('NEXT')}
                                        </button>
                                    </div>

                                    {/* <div className="d-flex align-items-center">
								<label className="me-2 mb-0">{t('GO_TO_PAGE')}:</label>
								<input
									type="number"
									className="form-control form-control-sm"
									min={1}
									max={totalPages}
									style={{ width: '70px' }}
									value={currentPage}
									onChange={(e) => {
										const val = parseInt(e.target.value);
										if (!isNaN(val)) goToPage(val);
									}}
								/>
							</div> */}
                                </div>

                                <hr />

                                <div className="btn-wrapper">
                                    <button type="button" className="btn btn-warning btn-rounded btn-wide me-2"
                                        onClick={() => openActionConfirm('cancel')}>
                                        {t('CANCEL')}
                                    </button>
                                    <button type="button" className="btn btn-success btn-rounded btn-wide me-2"
                                        disabled={!data.productList?.length > 0}
                                        onClick={() => setModalConfirm(true)}>{t('COMPLETE')}</button>
                                    <button type="button" className="btn btn-primary btn-rounded btn-wide"
                                        disabled={!data.productList?.length > 0}
                                        onClick={() => openActionConfirm('draft')}>{t('SAVE_TO_DRAFT')}</button>
                                </div>
                            </div>
                        </div>

                    </form>
                </>
            )}

            {/* MODAL NOT INVENTORED PRODUCTS */}
            <Modal show={modalNotInventored} animation={false} centered size="lg" backdrop="static" onHide={() => setModalNotInventored(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className="d-flex">
                            <div className="me-4">{t('ANNUAL')}</div>
                            <div className="form-check form-switch form-switch-lg">
                                <input type="checkbox" className="form-check-input"
                                    defaultValue={false} onChange={(e) => setAnnual(e.target.checked)} />
                            </div>
                            <div className="me-2">{t('SORT_BY')}</div>
                            <button
                                className={
                                    "btn btn-sm me-2 " +
                                    (sort === 'balance' && order === 'asc' ? "btn-primary" : "btn-success")
                                }
                                onClick={() => sortBy('balance', 'asc')}
                            >
                                [0-9]
                            </button>
                            <button
                                className={
                                    "btn btn-sm me-2 " +
                                    (sort === 'balance' && order === 'desc' ? "btn-primary" : "btn-success")
                                }
                                onClick={() => sortBy('balance', 'desc')}
                            >
                                [9-0]
                            </button>
                            <button
                                className={
                                    "btn btn-sm me-2 " +
                                    (sort === 'name' && order === 'asc' ? "btn-primary" : "btn-success")
                                }
                                onClick={() => sortBy('name', 'asc')}
                            >
                                [A-Z]
                            </button>

                            <button
                                className={
                                    "btn btn-sm me-2 " +
                                    (sort === 'name' && order === 'desc' ? "btn-primary" : "btn-success")
                                }
                                onClick={() => sortBy('name', 'desc')}
                            >
                                [Z-A]
                            </button>

                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mt-2">
                        <div className="form-group col-md-12">
                            <label>{t('SEARCH')}:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={filterData.search}
                                onChange={(e) => setFilterData({ ...filterData, search: e.target.value })}
                                placeholder={t('SEARCH') + '...'}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <label>{t('NON_EXISTENT_PERIOD_INVENTORY')}:</label>
                            <div className="calendar-input">
                                <DatePicker
                                    className="form-control"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filterData.startDate ? new Date(filterData.startDate) : ''}
                                    onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
                                <i className="uil uil-calendar-alt"></i>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label className="invisible">.</label>
                            <div className="calendar-input">
                                <DatePicker
                                    className="form-control"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filterData.endDate ? new Date(filterData.endDate) : ''}
                                    onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
                                <i className="uil uil-calendar-alt"></i>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="table-responsive inventory-modal-height">
                        <table className="table table-striped mb-0">
                            <thead>
                                <tr>
                                    <th>{t('NAME_OF_PRODUCT')}</th>
                                    <th className="text-center">{t('BARCODE')}</th>
                                    <th className="text-center">{t('EXPECTED_BALANCE')}</th>
                                    <th className="text-center">{t('COUNTED')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {notInventoredProducts.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className="d-flex">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={'control' + index}
                                                        onChange={(e) => markAsSelected(e.target.checked, index)}
                                                    />
                                                </div>

                                                <label
                                                    className="form-check-label vertical-center text-truncate ms-2"
                                                    htmlFor={'control' + index}
                                                    style={{ width: '300px' }}
                                                >
                                                    {item.productName}
                                                </label>
                                            </div>
                                        </td>

                                        <td className="text-center">{item.barcode}</td>
                                        <td className="text-center">{item.balance}</td>
                                        <td className="d-flex justify-content-center">
                                            <div className="d-flex">
<input type="number" step="0.01" inputMode="decimal" className="auto-width-input me-2" autoComplete="off"
                                                    name="actualBalance" value={item.actualBalance} onChange={(e) => setActualBalanceModal(e, index)} />
                                                <div className="table-action-button table-action-primary-button"
                                                    onClick={() => addToListNotInventoredProduct(index)}>
                                                    <i className="uil-plus"></i>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>
                    {notInvPageCount > 1 && (
                        <div className="mt-3 d-flex justify-content-center">
                            <Pagination pageCount={notInvPageCount} paginate={paginateNotInventored} />
                        </div>
                    )}

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" tabIndex="-1" onClick={() => exportToExcel()}>EXCEL</button>
                    <button className="btn btn-info" tabIndex="-1" onClick={() => addToListMinusBalanceProducts()}>{t('ADD_NEGATIVE_BALANCE')}</button>
                    <button className="btn btn-success" tabIndex="-1" onClick={() => addToListSelectedProducts()}>{t('ADD_SELECTED')}</button>
                    <button className="btn btn-primary" tabIndex="-1" onClick={() => addToListNotInventoredProducts()}>{t('ADD_ALL')}</button>
                </Modal.Footer>
            </Modal >
            {/* MODAL NOT INVENTORED PRODUCTS */}

            {/* MODAL CONFIRM */}
            <Modal show={modalConfirm} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => setModalConfirm(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('CONFIRM')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                        <div>{t('POS')}</div>
                        <div className="fw-700">{findFromArrayById(poses, data.posId)}</div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-100">
                        <button className="btn btn-warning w-100 me-2" onClick={() => setModalConfirm(false)}>
                            {t('CANCEL')}
                        </button>
                        <button className="btn btn-primary w-100" onClick={() => inventoryCompleted(true)}>{t('CONFIRM')}</button>
                    </div>
                </Modal.Footer>
            </Modal>
            {/* MODAL CONFIRM */}

            <Modal show={modalActionConfirm} animation={false} centered dialogClassName="update-modal-width" backdrop="static"
                onHide={() => setModalActionConfirm(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('CONFIRM')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {confirmActionType === 'cancel' && <div>{t('ARE_YOU_SURE_YOU_WANT')} {t('CANCEL')}?</div>}
                    {confirmActionType === 'draft' && <div>{t('ARE_YOU_SURE_YOU_WANT')} {t('SAVE_TO_DRAFT')}?</div>}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-100">
                        <button className="btn btn-warning w-100 me-2" onClick={() => setModalActionConfirm(false)}>
                            {t('CANCEL')}
                        </button>
                        <button className="btn btn-primary w-100" onClick={confirmAction}>
                            {t('CONFIRM')}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* MODAL INSTANT UPDATE PRODUCT */}
            <Modal show={modalUpdateProduct} animation={false} centered dialogClassName="update-modal-width"
                backdrop="static" onHide={() => showProductUpdateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('PRODUCT')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={changeProduct} autoComplete="off">
                        <div className="form-group">
                            <label>{t('NAME_OF_PRODUCT')}<span className="required-mark">*</span></label>
                            <input type="text" className="form-control" name="name" autoFocus
                                value={selectedItem.name}
                                onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label>{t('CATEGORY')}</label>
                            <Select
                                components={{ Option }}
                                classNamePrefix="react-select"
                                options={categories}
                                value={categoriesInitial.find(option => option.id === selectedItem.categoryId)}
                                onChange={(option) => setSelectedItem({ ...selectedItem, 'categoryId': option.id })}
                                placeholder=""
                                noOptionsMessage={() => t('LIST_IS_EMPTY')}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.id}
                            />
                        </div>
                        <div className="d-flex w-100 mt-3">
                            <button type="button" className="btn btn-outline-warning w-100 me-2"
                                onClick={() => showProductUpdateModal(false)} tabIndex="-1">{t('CANCEL')}</button>
                            <button type="submit" className="btn btn-primary w-100">{t('SAVE')}</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            {/* MODAL INSTANT UPDATE PRODUCT */}

            {/* MODAL BARCODE SCANNER */}
            <Modal show={modalScanner} animation={false} centered onHide={() => { setModalScanner(false); setScannerZoom(1); }}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('BARCODE_SCANNER')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ width: '100%', height: '300px', overflow: 'hidden', position: 'relative' }}>
                        <div style={{ width: '100%', height: '100%', transform: `scale(${scannerZoom})`, transformOrigin: 'center center' }}>
                            <Scanner
                                formats={['qr_code', 'code_128', 'code_39', 'ean_13', 'ean_8', 'upc_a', 'upc_e', 'itf', 'data_matrix', 'aztec']}
                                onScan={(result) => {
                                    if (result && result[0]?.rawValue) {
                                        setSearch(result[0].rawValue)
                                        setBarcode(true)
                                        setModalScanner(false)
                                        setScannerZoom(1)
                                    }
                                }}
                                constraints={{ facingMode: 'environment' }}
                                styles={{
                                    container: { width: '100%', height: '100%' },
                                    video: { width: '100%', height: '100%', objectFit: 'cover' }
                                }}
                            />
                        </div>
                    </div>
                    {/* Zoom Controls */}
                    <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
                            onClick={() => setScannerZoom(prev => Math.max(1, prev - 0.5))}
                            disabled={scannerZoom <= 1}
                        >
                            <i className="uil uil-minus"></i>
                        </button>
                        <span style={{ minWidth: '60px', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>{scannerZoom}x</span>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
                            onClick={() => setScannerZoom(prev => Math.min(4, prev + 0.5))}
                            disabled={scannerZoom >= 4}
                        >
                            <i className="uil uil-plus"></i>
                        </button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-warning w-100" onClick={() => { setModalScanner(false); setScannerZoom(1); }}>
                        {t('CANCEL')}
                    </button>
                </Modal.Footer>
            </Modal>
            {/* MODAL BARCODE SCANNER */}
        </>
    )
}

export default CreateUpdate
